














































































































import Ajax from '../../../lib/ajax'
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import User from '../../../store/entities/user'
import selectTree from '../../../components/selectTree/selectTree.vue'
@Component({
  components: { selectTree },
})
export default class CreateUser extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean
  user: any = {
    userName: '',
    password: '',
    confirmPassword: '',
    isActive: true,
    organizationUnitIds: [],
    name: '',
    number: '',
    post: '',
    causeDepartment: '',
    emailAddress: '',
    phoneNumber: '',
    joinedCompanyDate: '',
    job: '',
    roleNames: [],
  }
  treeData = []
  async created() {
    let _this = this
    setTimeout(() => {
      _this.getTree()
    }, 1000)
  }

  @Watch('$store.state.department.departmentTree2', { immediate: true, deep: true })
  onDepartmentTree2Change(newValue: any, oldValue: any) {
    if (newValue !== oldValue) {
      this.getTree() // departmentTree2 发生变化时调用 getTree() 方法
    }
  }

  get selectValue() {
    let tz = this.$store.state.user.selectInit
    return tz
  }
  get roles() {
    return this.$store.state.user.roles
  }
  async getTree() {
    // let respone = this.$store.state.department.departmentTree3
    // this.editeTreeValue(respone);
    // this.treeData = respone;
    let respone = await Ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnitTree')
    this.editeTreeValue(respone.data.result)
    this.treeData = respone.data.result
    this.$emit('postComponent', this)
  }
  // selectChange(data){
  // 	this.user['organizationUnitIds'] = data.toString()
  // }
  organizationID() {
    this.user['organizationUnitIds'] = []
  }
  selectChange(data) {
    this.organizationID()
    this.user['organizationUnitIds'] = data
    console.log(this.user['organizationUnitIds'])
  }
  selectChangePost(data) {
    this.user['post'] = data.toString()
  }
  selectChangeWorkStatus(data) {
    this.user['workStatus'] = data.toString()
  }
  removeRoot(data) {
    this.user['organizationUnitIds'] = data
  }
  editeTreeValue(data) {
    for (let i = 0; i < data.length; i++) {
      data[i].title = data[i].displayName
      data[i].value = data[i].id
      if (data[i].children) {
        if (data[i].children.length > 0) {
          data[i].expand = true
        }
        this.editeTreeValue(data[i].children)
      }
    }
  }
  organiValue(data) {
    this.user['organizationUnitIds'] = data
  }
  changeTimeEnterUnit(e, date) {
    this.user['joinedCompanyDate'] = e
  }
  save() {
    ;(this.$refs.userForm as any).validate(async (valid: boolean) => {
      if (valid) {
        let json = JSON.parse(JSON.stringify(this.user))
        json.organizationUnitIds = []
        json.organizationUnitIds = this.user['organizationUnitIds']
        await this.$store.dispatch({
          type: 'user/create',
          data: json,
        })
        ;(this.$refs.userForm as any).resetFields()
        this.$emit('save-success')
        this.$emit('input', false)
      }
    })
  }
  cancel() {
    ;(this.$refs.userForm as any).resetFields()
    this.$emit('input', false)
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value)
    } else {
      if (this.$refs.userForm) {
        ;(this.$refs.userForm as any).resetFields()
      }
      this.user.organizationUnitIds = []
    }
  }
  validatePassCheck = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback(new Error('必填项不能为空'))
    } else if (value === this.user.password) {
      callback()
    } else {
      callback(new Error('两次密码不一致'))
    }
  }
  passwordValid = (rule: any, value: any, callback: any) => {
    let reg =
      /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`~()-+=]+$)(?![0-9\\W_!@#$%^&*`~()-+=]+$)(?![a-zA-Z0-9]+$)(?![a-zA-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9\\W_!@#$%^&*`~()-+=]+$)(?![0-9A-Z\\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`~()-+=]{8,}$/
    if (!value) {
      callback(new Error('必填项不能为空'))
    } else if (!reg.test(value)) {
      callback(new Error('密码要求长度大于8位，且包含大写字母、小写字母、数字、特殊符号'))
    } else {
      callback()
    }
  }
  rerequiredOrgan = (rule: any, value: any, callback: any) => {
    // if (!this.user['organizationUnitIds'] || this.user['organizationUnitIds'].length==0) {
    if (value === '' || value === undefined || value === null) {
      callback(new Error('必填项不能为空'))
    } else {
      callback()
    }
  }
  //判断请假日期
  validateDate = (rule, value, callback) => {
    if (value == '' || value === undefined || value === null) {
      callback(new Error('日期不能为空'))
    } else {
      callback()
    }
  }

  userRule = {
    //organizationUnitIds:[{required: true,message:'必填项不能为空',trigger: 'change'}],
    organizationUnitIds: [
      { required: true, message: '必填项不能为空', trigger: 'blur', type: 'array' },
      { validator: this.rerequiredOrgan, trigger: 'change' },
    ],
    userName: [{ required: true, message: '必填项不能为空', trigger: 'blur' }],
    name: [{ required: true, message: '必填项不能为空', trigger: 'blur' }],
    number: [{ required: true, message: '必填项不能为空', trigger: 'blur' }],
    post: [{ required: true, message: '必选项不能为空', trigger: 'blur,change', type: 'number' }],
    // workStatus: [{ required: true, message: '必选项不能为空', trigger: 'blur,change', type: 'number' }],
    emailAddress: [
      { required: true, message: '必填项不能为空', trigger: 'blur' },
      { type: 'email', message: '邮箱格式不正确', trigger: 'blur' },
    ],
    password: [
      { required: true, message: '必填项不能为空', trigger: 'blur' },
      {
        validator: this.passwordValid,
        message: '密码要求长度大于8位，且包含大写字母、小写字母、数字、特殊符号',
        trigger: 'blur',
      },
    ],
    confirmPassword: [
      { required: true, message: '必填项不能为空', trigger: 'blur' },
      { validator: this.validatePassCheck, message: '两次密码不一致', trigger: 'change' },
    ],
    // joinedCompanyDate:[{required:true,message:'必填项不能为空',trigger: 'blur',type:'date'}],
    joinedCompanyDate: [
      {
        required: true,
        pattern: /.+/,
        validator: this.validateDate,
        trigger: 'blur',
      },
    ],
  }
}
